export default __webpack_public_path__ + "static/media/icon-coaching-session.826bb89b.svg";